import { GoMail } from "react-icons/go";
import { Link } from "react-router-dom";
import AccountLayout from "./AccountLayout";
import { useInbox } from "../libs/useReviews";
import { AccountInboxSkeleton } from "./AccountSkeletons";
import "./UserProfile.css";

const Customermsginbox = () => {
  const { data: inbox = [], isLoading } = useInbox();

  return (
    <AccountLayout title={isLoading ? undefined : "Inbox"} loading={isLoading}>
      {isLoading ? (
        <AccountInboxSkeleton />
      ) : (
        <>
          {inbox.length === 0 && (
            <div className="account-empty">
              <div className="account-empty__icon">
                <GoMail />
              </div>
              <h3>Your inbox is empty</h3>
              <p>Messages and order updates will appear here.</p>
            </div>
          )}
          <div className="inbox-list">
            {inbox.map((item) => (
              <div key={`${item.type}-${item.id}`} className="inbox-item">
                <span className={`inbox-type inbox-type-${item.type}`}>
                  {item.type === "message" ? "Message" : "Order update"}
                </span>
                <h4>{item.title}</h4>
                <p>{item.body}</p>
                <small>{new Date(item.date).toLocaleString()}</small>
                <div className="inbox-item-actions">
                  {item.trackLink && <Link to={item.trackLink}>Track order</Link>}
                  {item.link && <Link to={item.link}>View order</Link>}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </AccountLayout>
  );
};

export default Customermsginbox;
